import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { Md5 } from 'ts-md5/dist/md5';

@Directive({
  selector: '[appGravatar]'
})
export class GravatarDirective implements OnInit {

  @Input() set user(user: any) {
    this.updateGravatar(user);
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {
    if (this.el) {
      this.renderer.setAttribute(this.el.nativeElement, 'src', `//www.gravatar.com/avatar/`);
    }
  }

  ngOnInit(): void {
  }

  updateGravatar(user: any): void {
    if (!user || !this.el.nativeElement) {
      return;
    }

    // If profilePic exists, use it, otherwise use gravatar
    if (user.metadata?.photoURL || user?.photoURL) {
      this.renderer.setAttribute(this.el.nativeElement, 'src', user.metadata?.photoURL ?? user?.photoURL);
    } else {
      const emailHash = Md5.hashStr(user.metadata?.email?.trim().toLowerCase() ?? user.email?.trim().toLowerCase());
      this.renderer.setAttribute(this.el.nativeElement, 'src', `//www.gravatar.com/avatar/${emailHash}?d=wavatar`);
    }
  }
}
